export const show = (status) => {
  status.visible = true;
  status.button.classList.add("open");
  status.button.setAttribute("aria-expanded", "true");
  status.panel.setAttribute("aria-hidden", "false");
  status.panel.style.height = status.panel.height;
};
